module.exports = __webpack_public_path__ + "static/img/articles-the-formation-opportunity.e560f99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/articles-the-formation-opportunity.png
// module id = Lfqw
// module chunks = 0